export class ErrorLog {
  public createdDate: Date;
  public id: number;
  public message: string;
  public ownerID: number;
  public respondentID: number;
  public source: string;
  public stackTrace: string;
  public type: string;
}
